import { Injectable } from '@angular/core';
import { CacheListener } from './@utils/cache-listener';
import { Company } from 'interfaces/common/db/models/companies';
import dexFreight from '@microservices';
import { UserService } from './user.service';
import { Subscription } from 'rxjs';
import { Repository } from './@core/classes/Repository.class';
import { DbService } from './@core/db.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  public company: CacheListener<Company & { _id: string } | null> = new CacheListener("company",null, this.syncCompany.bind(this));
  public companyLogo: CacheListener<string | null> = new CacheListener("company-logo", null, this.syncCompanyLogo.bind(this));
  
  private companies: Repository<Company>;
  private listeners: Subscription[] = [];

  constructor(
    private userService: UserService,
    private db: DbService
  ) {
    
    this.companies = new Repository<Company>({
      sync: this._getCompany.bind(this),
      db: this.db.companies
    });
  }

  setupListeners () {
    this.listeners.push(
      this.company.syncWhenPropertyChanges(this.userService.user, 'companyId'),
      this.companyLogo.syncWhenChanges(this.company),

      this.companyLogo.bind(this.company),
      this.company.bind(this.userService.user)
    );
  }

  removeListeners () {
    this.listeners.forEach(listener => listener.unsubscribe());
  }

  async getCompany (id: string) {
    return await this.companies.value(id);
  }

  async companyListener (id: string) {
    return await this.companies.listener(id);
  }

  private async _getCompany (id: string) {
    return await dexFreight.Companies.get(id);
  }

  async syncCompany () {
    const user = await this.userService.user.get();
    if (!user?.companyId) return null;

    return await dexFreight.Companies.get(user.companyId);
  }

  async syncCompanyLogo () {
    const company = await this.company.get() as (Company & { _id: string; logo?: string }) | null;

    return company?.logo ?? null;
  }
}
